import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ExpertQuote() {
  return <section className="w-full px-4 py-16 max-w-3xl mx-auto" data-id="element-70">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative bg-white p-8 md:p-12 rounded-2xl shadow-lg border border-forest/10" data-id="element-71">
        <Quote className="absolute top-6 left-6 w-12 h-12 text-forest/20 transform -scale-x-100" data-id="element-72" />

        <div className="relative z-10" data-id="element-73">
          <p className="font-serif text-xl md:text-2xl text-gray-800 leading-relaxed italic text-center mb-8 pt-4" data-id="element-74">
            "Blähungen bei Hunden sind oft ein Zeichen einer gestörten
            Darmflora. Präbiotika wie Inulin und Topinambur können hier sehr
            effektiv sein – sie fördern das Wachstum nützlicher Bakterien und
            reduzieren Gärungsprozesse im Darm nachhaltig."
          </p>

          <div className="flex items-center justify-center gap-4" data-id="element-75">
            <div className="w-12 h-12 bg-forest/10 rounded-full flex items-center justify-center" data-id="element-76">
              <span className="font-serif font-bold text-forest text-xl" data-id="element-77">
                Dr.
              </span>
            </div>
            <div className="text-left" data-id="element-78">
              <p className="font-serif font-bold text-gray-900" data-id="element-79">
                Dr. Nane Schomburg
              </p>
              <p className="font-serif text-sm text-forest" data-id="element-80">Tierärztin</p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}